import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { ConfigurationService } from '../configuration.service';
import { Client } from '../models/client';
import { OauthAuthRequest } from '../models/oauth-auth-request';
import { OauthAuthResponse } from '../models/oauth-auth-response';

@Component({
  selector: 'app-authorize',
  templateUrl: './authorize.component.html',
  styleUrls: ['./authorize.component.css'],
})
export class AuthorizeComponent implements OnInit {
  response_type = '';
  client_id = '';
  redirect_uri = '';
  code_challenge: string | null = null;
  state: string | null = null;
  code_challenge_method: string | null = null;
  client: Client | null = null;
  requesting_application: string | null = null;

  constructor(
    private api: ApiService,
    private router: Router,
    private config: ConfigurationService
  ) {}

  ngOnInit(): void {
    const urlSearchParams = new URLSearchParams(window.location.search);

    const response_type = urlSearchParams.get('response_type');
    const client_id = urlSearchParams.get('client_id');
    const redirect_uri = urlSearchParams.get('redirect_uri');
    const requesting_application = urlSearchParams.get(
      'requesting_application'
    );
    this.code_challenge = urlSearchParams.get('code_challenge');
    this.code_challenge_method = urlSearchParams.get('code_challenge_method');
    this.state = urlSearchParams.get('state');

    if (client_id == null || response_type == null || redirect_uri == null) {
      this.router.navigate(['/']);
      return;
    }

    this.client_id = client_id;
    this.response_type = response_type;
    this.redirect_uri = redirect_uri;
    this.requesting_application = requesting_application;

    this.api.getClient(client_id).subscribe((data: Client) => {
      if (data.verified) {
        this.authorize();
      } else {
        this.client = data;
      }
    });
  }

  //TODO required_pty: true
  public authorize() {
    const request: OauthAuthRequest = {
      client_id: this.client_id,
      response_type: this.response_type,
      redirect_uri: this.redirect_uri,
      code_challenge: this.code_challenge,
      code_challenge_method: this.code_challenge_method,
      state: this.state,
    };

    this.api.oauthAuthorize(request).subscribe(
      (data: OauthAuthResponse) => {
        // TODO: if no redirect, should give error
        window.location.href = data.redirect_url;
      },
      (err) => {
        console.error(err);
      }
    );
  }
}
